// generate a list of years from an argument year to current year + 1
const generateYearsList = (
  startYear: number,
  numberOfYearsInTheFuture?: number,
): number[] => {
  const endYear = new Date().getFullYear() + (numberOfYearsInTheFuture ?? 1);

  const years: number[] = [];
  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }
  return years;
};

// Generate possible methodology years for WUR Reporter and WUR Explore
// Despite the list having all possible years for each product,
// ONLY when there is a release for a year
// AND the user has permission to see it will it be shown to the user.
// The years will be filtered in the ScenarioDataProvider component after
// retrieving the releases data. The backend decides which uses the user
// has access to, including embargoed ones.

// Since WUR Reporter started in 2024, we start from there
export const POSSIBLE_METHODOLOGY_YEARS_WUR_REPORTER = generateYearsList(2024);

// Since WUR Explore started in 2023, we start from there
export const POSSIBLE_METHODOLOGY_YEARS_WUR_EXPLORE = generateYearsList(2023);

export const YEAR_OF_START_OF_WUR_3_0 = 2024;
